import { Key } from 'react'
import { Autocomplete, AutocompleteItem } from '@heroui/autocomplete'
import { ChangeEvent, LucideIconName } from '@bm-js/atlascloud-shared'
import styled from 'styled-components'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'
import { Icon, LucideIcons } from '@bm-js/atlascloud-ui'
import { _objectKeys } from '@naturalcycles/js-lib/types'

const StyledSvgInput = styled.div`
  input {
    border: none !important;
  }
`

const icons = _objectKeys(LucideIcons).map((key) => ({
  label: key + '_label',
  value: key,
}))

type Props = {
  name?: string
  value?: LucideIconName
  onChange: (event: ChangeEvent<LucideIconName>) => void
}

const SVGInput = (props: Props) => {
  const { tr } = useTr()

  const onSelectionChange = (id: Key | null) => {
    const key = (id as string)?.split('_')[0] as LucideIconName
    if (!key) return

    const event = {
      target: {
        name: props.name,
        value: key,
      },
    } as ChangeEvent<LucideIconName>

    props.onChange(event)
  }

  return (
    <StyledSvgInput className='flex w-full flex-col'>
      <Autocomplete
        label={tr(TrKey.svgInputLabel)}
        placeholder={tr(TrKey.svgInputPlaceholder)}
        variant='bordered'
        defaultItems={icons}
        defaultSelectedKey={props.value}
        defaultInputValue={props.value}
        allowsCustomValue={true}
        onSelectionChange={onSelectionChange}
      >
        {(item) => (
          <AutocompleteItem key={item.label} textValue={item.value}>
            <div className='flex gap-3'>
              <Icon name={item.value} />
              {item.value}
            </div>
          </AutocompleteItem>
        )}
      </Autocomplete>
    </StyledSvgInput>
  )
}

export default SVGInput
